if(!customElements.get('section-timeline')) {
  class SectionTimeline extends HTMLElement {
    constructor() {
      super();
      var section = this;

      var steps = section.querySelector('.steps');

      // 'Full height' mode draws the line in CSS, so the scroll progress must
      // not write an inline height over it.
      var fullLine = section.classList.contains('line-full');

      // Distance from the top of .steps down to the last dot. Measured from the
      // dot itself rather than assumed to be the top of the last step, so the
      // line still reaches it when steps are vertically centered. offsetTop is
      // used instead of getBoundingClientRect so the dots' scale-in transform
      // does not skew the result.
      var lineLength = function(){
        var lastItem = steps.querySelector('.item.last') || steps.querySelector('.item:last-child');
        if (!lastItem) return 0;
        var lastDot = lastItem.querySelector('.number-wrap');
        return lastItem.offsetTop + (lastDot ? lastDot.offsetTop : 0) + 2;
      }

      var beginEnd = function(){
        var stepsOffset = steps.getBoundingClientRect().top + window.scrollY;
        var begin = stepsOffset - window.innerHeight + (window.innerHeight / 2.75);
        var end = begin + lineLength();
        var lineHeight = end - begin;
        if (window.scrollY >= begin && window.scrollY <= end){
          lineHeight = window.scrollY - begin;
        } else if (window.scrollY < begin) {
          lineHeight = 0;
        }
        if (!fullLine) {
          section.querySelector('.line').style.height = lineHeight + 'px';
        }
        section.querySelectorAll('.item').forEach(function(element){
          var appear = (element.getBoundingClientRect().top + window.scrollY) - window.innerHeight + (window.innerHeight / 2.75);
          if (window.scrollY >= appear){
            element.classList.add('appear');
          }else{
            element.classList.remove('appear');
          }
        });
      }
      beginEnd();
      window.addEventListener('scroll', (e)=> {
        beginEnd();
      });
    
    }
  }
  customElements.define('section-timeline', SectionTimeline);
}